import { Map } from 'maplibre-gl';
import { type MapOptions } from 'maplibre-gl';
import React, { useRef, useEffect, useState } from 'react';
import styled from 'styled-components';

// Registers the maplibre worker URL and type (side effect) before any Map is created.
import './maplibreWorker.ts';
import { getEffectiveViewLimits } from './surround/getEffectiveViewLimits.ts';
import type { MapInstance, SurroundConfig, ViewLimits } from './types.ts';

const MapContainerDiv = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

const DescriptionDiv = styled.div`
  display: none;
`;

type MapComponentProps = {
  onInit: (map: MapInstance) => void;
  viewLimits: ViewLimits;
  surroundConfig?: SurroundConfig;
  preserveDrawingBuffer?: boolean;
};

function MapComponent({ onInit, viewLimits, surroundConfig, preserveDrawingBuffer }: MapComponentProps) {
  const ref = useRef<HTMLDivElement | null>(null);
  const [map, setMap] = useState<MapInstance | null>(null);

  useEffect(() => {
    if (ref.current && !map) {
      const effectiveViewLimits = getEffectiveViewLimits(viewLimits, surroundConfig);
      const newMap = new Map({
        container: ref.current,
        attributionControl: false,
        ...(preserveDrawingBuffer && { canvasContextAttributes: { preserveDrawingBuffer: true } }),
        ...effectiveViewLimits,
      } as MapOptions);
      setMap(newMap);
      onInit(newMap);
    }
  }, [map, onInit, preserveDrawingBuffer, surroundConfig, viewLimits]);

  return (
    <MapContainerDiv ref={ref}>
      <DescriptionDiv id="MapDescription" />
    </MapContainerDiv>
  );
}

export default MapComponent;
